import React from 'react';
import {_Object} from "react-utils-y";
import {defaultPublic} from "../formStyle";

const checkboxSty = (_theme, _this) => {
    let publicSty = defaultPublic(_theme, _this);
    let sty = {
        checkboxBox: {
            display: "flex",
            alignItems: "center",
            flexWrap: "wrap",
            height: "100%",
            // padding: "0 0.4rem",
            justifyContent: _this.props.valueAlign == "center" ? "space-around" : "",
        },
        checkboxItem: {
            display: "flex",
            marginLeft: "1rem",
            cursor: "pointer",
            alignItems: "center",
            height: "2rem",
        },
        checkboxItemDis: {
            display: "flex",
            marginRight: "1rem",
            color: `${_theme.publicForm.disValueColor || '#ccc'}`,
        },
        checkboxSvg: {
            display: "flex",
            alignItems: "center",
        },
        checkboxText: {
            marginLeft: "0.625rem",
            fontSize: `${_theme.publicForm.textFontSize || ""}`,
        },
    };
    return _Object.merge(publicSty, sty)
};

export {
    checkboxSty,
};